import { getCookie } from './cookie-service';

export const JOOBLE_UTM_COOKIE = 'joobleUtm';
export const JOOBLE_UTM_PARAM = 'utm_away';

const normalize = (raw) => {
  if (raw == null) return '';
  const value = Array.isArray(raw) ? raw[0] : raw;
  return typeof value === 'string' ? value.trim() : '';
};

const readFromQuery = () => {
  if (typeof window === 'undefined' || !window.location) return '';
  try {
    return normalize(new URLSearchParams(window.location.search).get(JOOBLE_UTM_PARAM));
  } catch (error) {
    return '';
  }
};

export const getJoobleUtm = () => readFromQuery() || normalize(getCookie(JOOBLE_UTM_COOKIE));

const isFormData = (value) =>
  typeof FormData !== 'undefined' && value instanceof FormData;

// Returns the payload UNCHANGED when there is no utm_away, so an organic
// applicant's request stays byte-identical. FormData is mutated in place
// (its callers build a fresh instance per submit); plain objects are copied.
export const withJoobleUtm = (payload) => {
  const value = getJoobleUtm();
  if (!value) return payload;

  if (isFormData(payload)) {
    if (!payload.has(JOOBLE_UTM_PARAM)) {
      payload.append(JOOBLE_UTM_PARAM, value);
    }
    return payload;
  }

  if (payload && typeof payload === 'object') {
    if (payload[JOOBLE_UTM_PARAM] != null && payload[JOOBLE_UTM_PARAM] !== '') {
      return payload;
    }
    return { ...payload, [JOOBLE_UTM_PARAM]: value };
  }

  return payload;
};
